import { SelectOptions } from '../components/form/Options'

const mapEnumForSelect = (enumToUse: Record<string, string>): Array<SelectOptions> => {
  return Object.values(enumToUse).map((value) => ({ label: value, value: value }))
}

export default mapEnumForSelect
